import { defineStore } from 'pinia';
import { useQuasar } from 'quasar';

export const useGlobalStore = defineStore('global', () => {
  const $q = useQuasar();
  return { $q };
});
